// File: src/layouts/NoContainer.js
// requirement in layoutConfig (App.js)

import { useLocation } from "react-router-dom";

export default function NoContainer({ children }) {
  const location = useLocation();
  const isPublicFullBleed =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/register";
  const isApplicantWorkspace = location.pathname.startsWith("/dashboard/applicant");
  const isSecurityWorkspace = location.pathname.startsWith("/dashboard/security");

  if (isPublicFullBleed || isSecurityWorkspace || isApplicantWorkspace) {
    return <div className="min-h-screen p-0 m-0">{children}</div>;
  }

  return <div className="min-h-screen px-5 pt-20">{children}</div>;
}
